import React from "react"
import { ReportAPI } from "../../../lib/utils"
import ReportForm from "../ReportForm"

export default function BucketPerformanceReport() {
  return <ReportForm reportAPI={ ReportAPI.BUCKET_PERFORMANCE } />
}



// WEBPACK FOOTER //
// ./src/components/Reports/financiers/BucketPerformance.js